const PROFILE_KEY_PREFIX = 'cso_user_profile_';

export const DEFAULT_CERT_NOTIFY_OFFSET_DAYS = -30;
export const CERT_NOTIFY_OFFSET_MIN = -365;
export const CERT_NOTIFY_OFFSET_MAX = 365;

export function normalizeCertNotifyOffsetDays(value) {
  const parsed = Number(value);
  if (!Number.isFinite(parsed)) return DEFAULT_CERT_NOTIFY_OFFSET_DAYS;
  const rounded = Math.trunc(parsed);
  return Math.min(CERT_NOTIFY_OFFSET_MAX, Math.max(CERT_NOTIFY_OFFSET_MIN, rounded));
}

export function isSignatureImageDataUrl(value) {
  return typeof value === 'string' && value.startsWith('data:image');
}

/** Typed profile signature only (empty when the saved value is a drawn/uploaded image). */
export function profileSignatureText(signature = '') {
  if (isSignatureImageDataUrl(signature)) return '';
  return signature || '';
}

/** Split a saved profile signature into typed text vs drawn/uploaded image. */
export function splitProfileSignature(signature = '') {
  if (isSignatureImageDataUrl(signature)) {
    return { text: '', image: signature };
  }
  return { text: signature || '', image: '' };
}

export function normalizeUserProfile(profile = {}) {
  return {
    name: profile.name || '',
    signature: profile.signature || '',
    certificate_notify_offset_days: normalizeCertNotifyOffsetDays(
      profile.certificate_notify_offset_days
    ),
  };
}

export function describeCertNotifyOffset(days) {
  const offset = normalizeCertNotifyOffsetDays(days);
  if (offset === 0) return 'Notify on the expiry date';
  if (offset < 0) {
    const n = Math.abs(offset);
    return `Notify ${n} day${n === 1 ? '' : 's'} before expiry`;
  }
  return `Notify ${offset} day${offset === 1 ? '' : 's'} after expiry`;
}

export function getStoredUserProfile(email) {
  if (!email) return normalizeUserProfile();
  try {
    const raw = localStorage.getItem(`${PROFILE_KEY_PREFIX}${email}`);
    if (!raw) return normalizeUserProfile();
    return normalizeUserProfile(JSON.parse(raw));
  } catch {
    return normalizeUserProfile();
  }
}

export function setStoredUserProfile(email, profile) {
  if (!email) return;
  localStorage.setItem(
    `${PROFILE_KEY_PREFIX}${email}`,
    JSON.stringify(normalizeUserProfile(profile))
  );
}
